import { API_BASE_URL } from './firebase';
import { TrainingRecord, User, ApiResponse } from '../types';

export class ApiService {
  private static async makeRequest(url: string, method: 'GET' | 'POST' = 'GET', body?: any): Promise<any> {
    if (url.includes("YOUR_DEPLOYMENT_ID")) {
      throw new Error("Apps Script URL이 설정되지 않았습니다. firebase.ts 파일의 API_BASE_URL을 확인해주세요.");
    }

    try {
      let fetchOptions: RequestInit;
      let targetUrl = url;

      if (method === 'GET') {
        // GET 요청은 URL 파라미터 사용 (기존 방식 유지)
        fetchOptions = {
          method: 'GET',
        };
      } else {
        // POST 요청은 text/plain으로 전송하여 CORS Preflight 회피
        fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8',
          },
          body: JSON.stringify(body),
        };
        // POST 요청 시 쿼리 파라미터 제거
        targetUrl = API_BASE_URL;
      }

      const response = await fetch(targetUrl, fetchOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
      
    } catch (error: any) {
      console.error('API 요청 실패:', error);
      throw new Error(error.message || '서버 연결에 실패했습니다.');
    }
  }

  static async getTrainingData(userEmail: string): Promise<ApiResponse<TrainingRecord[]>> {
    const url = `${API_BASE_URL}?action=getTrainingData&email=${encodeURIComponent(userEmail)}`;
    return this.makeRequest(url, 'GET');
  }

  static async updateRecord(
    userEmail: string,
    recordId: string,
    updates: Partial<TrainingRecord>
  ): Promise<ApiResponse> {
    return this.makeRequest(API_BASE_URL, 'POST', {
      action: 'updateRecord',
      email: userEmail,
      recordId,
      updates,
    });
  }

  static async deleteRecord(
    userEmail: string,
    recordId: string
  ): Promise<ApiResponse> {
    return this.makeRequest(API_BASE_URL, 'POST', {
      action: 'deleteRecord',
      email: userEmail,
      recordId,
    });
  }

  static async getUserList(userEmail: string): Promise<ApiResponse<User[]>> {
    const url = `${API_BASE_URL}?action=getUserList&email=${encodeURIComponent(userEmail)}`;
    return this.makeRequest(url, 'GET');
  }

  static async addUser(
    userEmail: string,
    newUserEmail: string,
    name: string,
    role: 'developer' | 'admin' | 'viewer'
  ): Promise<ApiResponse> {
    return this.makeRequest(API_BASE_URL, 'POST', {
      action: 'addUser',
      email: userEmail,
      newUserEmail: newUserEmail,
      name,
      role,
    });
  }
}